export type DeliveryStatus = 'draft' | 'active' | 'paused';

export type DeliveryRecipient =
  | { type: 'user'; user_id: number }
  | { type: 'email'; address: string };

/**
 * Client-side guard aligned with maestro CreateDelivery / UpdateDelivery rules.
 */
export function validateDeliverySave(
  status: DeliveryStatus,
  recipients: DeliveryRecipient[],
): string | null {
  if (status === 'active' && recipients.length === 0) {
    return 'Add at least one recipient before marking the delivery active.';
  }
  return null;
}
